exports.components = {
  "component---src-templates-article-page-index-tsx": () => import("./../../../src/templates/article-page/index.tsx" /* webpackChunkName: "component---src-templates-article-page-index-tsx" */),
  "component---src-templates-error-page-index-tsx": () => import("./../../../src/templates/error-page/index.tsx" /* webpackChunkName: "component---src-templates-error-page-index-tsx" */),
  "component---src-templates-generic-page-index-tsx": () => import("./../../../src/templates/generic-page/index.tsx" /* webpackChunkName: "component---src-templates-generic-page-index-tsx" */)
}

